import { derived, readable, writable } from "svelte/store";
export const searchValue = writable("");
export const orderValue = writable("");
export const typeFilter = writable("");
export const totalItemCount = writable(0);
export const pageSelected = writable(0);
export const itemsInPage = writable(20);
export const pageOptions = derived([totalItemCount, itemsInPage], ([$totalItemCount, $itemsInPage]) => ({
    totalItemCount: $totalItemCount,
    itemsInPage: $itemsInPage
}));
export const modalPokemonName = writable({});
